export default __webpack_public_path__ + "static/media/diary.f2ea737b.svg";